import { indexData } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            按主题分类浏览，快速找到你最感兴趣的八卦内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item) => (
            <a
              key={item.id}
              href={`#index`}
              onClick={(e) => e.preventDefault()}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-200/50 transition-colors cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center mb-3 md:mb-4 ${colorMap[item.color]}`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="flex items-center justify-between mb-1.5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full">
                  {item.count}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}